module.exports = __webpack_public_path__ + "images/external_images/svg/components/contacts-primary-icon.svg";